/**
 * Single source of truth for z-index values.
 * - Use Tailwind classes (z-modal-backdrop, z-header, etc.) when possible.
 * - Use Z_INDEX only for inline styles (e.g. D3, third-party libs).
 *
 * Hierarchy (bottom → top):
 *   layer < modal-backdrop < modal-panel < header < fullscreen < overlay < toast
 */
export const Z_INDEX = {
    layer: 1,
    modalBackdrop: 20,
    modalPanel: 30,
    header: 40,
    fullscreen: 50,
    overlay: 100,
    toast: 110,
} as const;

/** Tailwind z-index config - import this in tailwind.config.js */
export const zIndexTailwindConfig = {
    layer: Z_INDEX.layer,
    "modal-backdrop": Z_INDEX.modalBackdrop,
    "modal-panel": Z_INDEX.modalPanel,
    header: Z_INDEX.header,
    fullscreen: Z_INDEX.fullscreen,
    overlay: Z_INDEX.overlay,
    toast: Z_INDEX.toast,
} as const;
